// Always include common JS to page-specific
import { loadOwlCarousel } from '../async/loadOwlCarousel.js';
import { ScrollableNav } from '../scrollable-nav';
import { ready } from '../utils/ready';
import { makeTableResponsive } from '../utils/makeTableResponsive'
import '/js/common/index';
import { initScrollToTopButton } from '../scroll-to-top';
import { initAddToBookMarksLogic, initArticleRating } from './functions';


ready(() => {
    const sliders = document.querySelectorAll('.bx-newsdetail-slider-container, .blog-article-header__images--slider');

    if (sliders.length) {
        loadOwlCarousel().then(() => {
            jQuery(sliders).owlCarousel({
                autoplay: true,
                autoplayTimeout: 5000,
                autoplaySpeed: 300,
                autoplayHoverPause: true,
                items: 1,
                dots: true,
                dotsEach: true,
                rewind: true
            });
        });
    }

    // Make sure no tables in blog article content overflow the screen
    for (const table of [...document.querySelectorAll('.text-content table')]) {
        makeTableResponsive(table);
    }

    // If on desktop layout
    if (document.querySelector('.desk#wrapper') instanceof HTMLElement) {
        const scrollables = document.querySelectorAll(`.${ScrollableNav.ELEMENT_CLASS}:not(.${ScrollableNav.INITIALIZATION_CLASS})`);

        for (const scrollable of [...scrollables]) {
            new ScrollableNav(scrollable);
        }
    }

    if (document.querySelector(('.blog-article'))) {
        initScrollToTopButton(() => {
            const location = window.location;

            if (location.hash) {
                const cleanUri = location.href.substring(0, location.href.indexOf("#"));
                window.history.replaceState({}, document.title, cleanUri);
            }
        });

        initArticleRating();
    }

    initAddToBookMarksLogic();
})